import { parseCsv, ParseError, type ParseResult } from './csv'

// parseWtt — Working Timetable parser. Spec 15 §3.3.
//
// Input shape (header row required):
//   time,service,loco,from,to,capacity
//   09:30,Service 1,Thomas (No.1),Pickering,Newbridge,320
//   …
//
// Output rows omit `id` / `eventId` / `booked` / `order` because those are
// set server-side at import time. The consumer (ImportWttModal) hands
// the array to the import endpoint as-is.
//
// Validation:
//   - time matches HH:mm
//   - capacity is a non-negative integer
//   - service, loco, from, to are non-empty after trim

export interface WttRow {
  time: string
  service: string
  loco: string
  from: string
  to: string
  capacity: number
  notes?: string
}

const TIME_RE = /^\d{2}:\d{2}$/

export function parseWtt(raw: string): ParseResult<WttRow> {
  return parseCsv<WttRow>(raw, {
    required: ['time', 'service', 'loco', 'from', 'to', 'capacity'],
    optional: ['notes'],
    mapRow: (c) => {
      if (!TIME_RE.test(c.time)) {
        throw new ParseError('Bad time (expected HH:mm)')
      }
      const cap = Number(c.capacity)
      if (!Number.isInteger(cap) || cap < 0) {
        throw new ParseError('Capacity must be a non-negative integer')
      }
      if (!c.service || !c.loco || !c.from || !c.to) {
        throw new ParseError('Missing required value')
      }
      return {
        time: c.time,
        service: c.service,
        loco: c.loco,
        from: c.from,
        to: c.to,
        capacity: cap,
        notes: c.notes || undefined
      }
    }
  })
}
